import './omcDialog.module';
import './omc-dialog.service';
import './omcDialog.directive';
import './omcDialogContainer.directive';
import './omc-dialog-view/omc-dialog-view.component';